export default __webpack_public_path__ + "static/media/filledStar.f49ac329.svg";